import { ClientProject, mapClientProjects } from "./ClientProjectInterface";

export interface Client {
    contactId: number;
    contactType: string;
    contactSubType: string;

    /*Personal Info*/
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    mobile: string;
    landline: string;
    address: string;
    city: string;
    post_code: string;
    profile_image: string;

    //Projects
    projects: ClientProject[];

    /*Role info*/
    user_role_info_id: number;
    user_role_id: number;
    display_role_name: string;
    role_name: string;

    domProjectId: number;
    domProjectContactId: number;
    domProjectAddress: string;
    domProjectCity: string;
    domProjectPostCode: string;
}

export const mapClient = (data: any): Client => {
    if (!data) {
        throw new Error('Invalied employee type')
    }

    const employee: Client = {
        contactId: data.contact_id,
        contactType: data.contact_type,
        contactSubType: data.contact_subtype,

        id: data.personalInfo.id,
        first_name: data.personalInfo.first_name,
        last_name: data.personalInfo.last_name,
        email: data.personalInfo.email,
        mobile: data.personalInfo.mobile,
        landline: data.personalInfo.landline,
        address: data.personalInfo.address,
        city: data.personalInfo.city,
        post_code: data.personalInfo.post_code,
        profile_image: data.personalInfo.profile_image,

        projects: mapClientProjects(data.commercialClientProjectInfo),

        user_role_info_id: data.userRoleInfo?.id || 0,
        user_role_id: data.userRoleInfo?.user_role_id || 0,
        display_role_name: data.userRoleInfo?.display_role_name || '',
        role_name: data.userRoleInfo?.role_name || '',

        domProjectId: data.domesticClientInfo?.id || 0,
        domProjectContactId: data.domesticClientInfo?.contact_id || 0,
        domProjectAddress: data.domesticClientInfo?.address || '',
        domProjectCity: data.domesticClientInfo?.city || '',
        domProjectPostCode: data.domesticClientInfo?.post_code || '',
    }

    return employee;
}

export const mapClients = (data: any[]): Client[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Employee data');
    }

    return data.map(mapClient);
};